module.exports = __webpack_public_path__ + "img/email.00ea3536.svg";